import { cookieName } from "utils/constants";

export function isAuthenticated() {
  return document.cookie.includes(`${cookieName}`);
}

export function getFormattedNumber(num) {
  if (parseInt(num) < 10) {
    return `0${num}`;
  }
  return num;
}

export const isCoinsOver = (board,m,n) => {
  for (var i = 0; i < m; i++) {
    for (var j = 0; j < n; j++) {
      if (board[i][j].includes("c")) {
        return false;
      }
    }
  }
  return true;
};

export const isSafeBerry = (board,key, idx, idy) => {
  switch (key) {
    case "left":
      if (
        // (board[idx][idy - 1].includes("b") &&
        //   this.isSafeBerry("left", idx, idy - 1)) ||
        board[idx][idy - 1].includes("g") ||
        board[idx][idy - 1].includes("c") ||
        board[idx][idy - 1].includes("p")
      ) {
        return true;
      } else {
        return false;
      }
    case "right":
      if (
          // (board[idx][idy + 1].includes("b") &&
        //   this.isSafeBerry("right", idx, idy + 1)  &&
        //   this.moveBerries("right", board[idx][idy + 1], idx, idy + 1)) ||
        board[idx][idy + 1].includes("g") ||
        board[idx][idy + 1].includes("c") ||
        board[idx][idy + 1].includes("p")
      ) {
        return true;
      } else {
        return false;
      }
    case "up":
      if (
        board[idx - 1][idy].includes("g") ||
        board[idx - 1][idy].includes("c") ||
        board[idx - 1][idy].includes("p")
      ) {
        return true;
      } else {
        return false;
      }
    case "down":
      if (
        board[idx + 1][idy].includes("g") ||
        board[idx + 1][idy].includes("c") ||
        board[idx + 1][idy].includes("p")
      ) {
        return true;
      } else {
        return false;
      }
    default:
  }
};
